export const AI_REASONING_EFFORTS = ['none', 'low', 'medium', 'high', 'xhigh', 'max'];
export const DEFAULT_MESSAGE_ENHANCE_MODEL = 'openai/gpt-oss-120b';
export const DEFAULT_MESSAGE_ENHANCE_MINIMUM_THROUGHPUT = null;
export const DEFAULT_MESSAGE_ENHANCE_PROVIDER = '';
export const DEFAULT_MESSAGE_ENHANCE_REASONING_EFFORT = 'low';
export const DEFAULT_AI_AGENT_MODEL = 'openai/gpt-oss-120b';
export const DEFAULT_AI_AGENT_MINIMUM_THROUGHPUT = null;
export const DEFAULT_AI_AGENT_PROVIDER = '';
export const DEFAULT_AI_AGENT_REASONING_EFFORT = 'medium';
export const DEFAULT_AI_COPILOT_MODEL = 'openai/gpt-oss-120b';
export const DEFAULT_AI_COPILOT_MINIMUM_THROUGHPUT = null;
export const DEFAULT_AI_COPILOT_PROVIDER = '';
export const DEFAULT_AI_COPILOT_REASONING_EFFORT = 'medium';
export const DEFAULT_AI_CHAT_RATING_MODEL = 'openai/gpt-oss-120b';
export const DEFAULT_AI_CHAT_RATING_MINIMUM_THROUGHPUT = null;
export const DEFAULT_AI_CHAT_RATING_PROVIDER = '';
export const DEFAULT_AI_CHAT_RATING_REASONING_EFFORT = 'low';
export function aiModelProvider(_model) {
    return 'openrouter';
}
export function aiProviderModelId(model) {
    return model;
}
export function aiModelSupportsReasoningEffort(_model, _effort) {
    return true;
}
//# sourceMappingURL=ai-models.js.map